import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
import * as Storage from "../../common/config/Storage";

export class CustomerViewModel extends BaseViewModel {
  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getCustomers = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var customerResponse = await this.getCustomerListByCodeTag();
    if (
      Format.isNotNull(customerResponse.errorCode) &&
      customerResponse.errorCode === 0
    ) {
      if (Format.isNotNull(customerResponse.businesses)) {
        this.updateState("customerList", customerResponse.businesses);
        this.logger.info(customerResponse.businesses);
      } else {
        this.showEmpty("Customer");
      }
    } else {
      this.showError("Customer", CrudlStatus.LIST);
    }
  };

  getCustomersReturned = async () => {
    //CRITICAL - ERROR + EMPTY MESSAGE
    var customerResponse = await this.getCustomerListByCodeTag();
    if (
      Format.isNotNull(customerResponse.errorCode) &&
      customerResponse.errorCode === 0
    ) {
      if (Format.isNotNull(customerResponse.customerList)) {
        this.logger.info(customerResponse.customerList);
        return customerResponse.customerList;
      } else {
        this.showEmpty("Customer");
      }
    } else {
      this.showError("Customer", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (
    customers,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedCustomerList = [];
    if (type === CrudlStatus.CREATE) {
      updatedCustomerList = this.reloadAfterCreate(
        customers,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedCustomerList = this.reloadAfterUpdate(
        customers,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedCustomerList = this.reloadAfterDelete(
        customers,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("customerList", updatedCustomerList);
  };

  reloadAfterCreate = (customerList, apiResponse, externalStateValues) => {
    if (customerList === undefined || customerList === null) {
      customerList = [];
    }
    var customerBean = externalStateValues.customerBean;
    customerBean.id = apiResponse.id;
    customerBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    customerList.push(customerBean);

    return customerList;
  };

  reloadAfterUpdate = (customerList, apiResponse, externalStateValues) => {
    var i = 0;
    customerList.forEach(e => {
      if (apiResponse.id === e.id) {
        customerList[i] = externalStateValues.customerBean;
        customerList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return customerList;
  };

  reloadAfterDelete = (customerList, apiResponse, externalStateValues) => {
    var i = 0;
    customerList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        customerList.splice(i, 1);
      }
      i++;
    });

    return customerList;
  };

  executeCRUDLAction = async (crudlStatus, stateVariables) => {
    let customerRequest = CloudService.BusinessRequest.constructFromObject(
      stateVariables.customerBean
    );
    if (crudlStatus === CrudlStatus.CREATE) {
      return await this.createCustomer(customerRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.UPDATE) {
      return await this.updateCustomer(customerRequest, stateVariables);
    }
    if (crudlStatus === CrudlStatus.DELETE) {
      return await this.deleteCustomer(customerRequest);
    }
  };

  createCustomer = async (customerRequest, stateVariables) => {
    customerRequest.codeTag = this.codeTag;
    customerRequest.userId = this.userId;

    let customerResponse = await ApiService.customerCreate(customerRequest);
    if (customerResponse.errorCode === 0) {
      this.showSuccess("Customer", CrudlStatus.CREATE);
    } else {
      this.showError("Customer", CrudlStatus.CREATE);
    }

    return customerResponse;
  };

  deleteCustomer = async customerRequest => {
    //RESET PRODUCT REQUEST
    var request = {};
    // request.codeTag = this.codeTag;
    // request.userId = this.userId;
    request.id = customerRequest.id;
    request.lastUpdatedDateTime = customerRequest.lastUpdatedDateTime;

    let customerResponse = await ApiService.customerDelete(request);
    if (customerResponse.errorCode === 0) {
      this.showSuccess("Customer", CrudlStatus.DELETE);
    } else {
      this.showError("Customer", CrudlStatus.DELETE);
    }

    return customerResponse;
  };

  updateCustomer = async (customerRequest, stateVariables) => {
    // customerRequest.codeTag = this.codeTag;
    // customerRequest.userId = this.userId;

    delete customerRequest.businessName;
    let customerResponse = await ApiService.customerUpdate(customerRequest);
    if (customerResponse.errorCode === 0) {
      this.showSuccess("Customer", CrudlStatus.UPDATE);
    } else {
      this.showError("Customer", CrudlStatus.UPDATE);
    }

    return customerResponse;
  };
}



// WEBPACK FOOTER //
// ./src/components/Customer/CustomerViewModel.js